import { Control, ControlType, KngFilterState, Section } from 'kinetic-angular';
import { ProfileLocation } from '../components/auth';
import { SharedFactoryDataService } from '../services/shared/shared-factory-data.service';

export const divisionControls: Control[] = [
	new Control({
		id: 'Division 1',
		label: 'Division 1',
		type: ControlType.checkbox,
		inputPlaceholderText: '',
		inputIcon: '',
		options: [],
		value: ''
	}),
	new Control({
		id: 'Division 2',
		label: 'Division 2',
		type: ControlType.checkbox,
		inputPlaceholderText: '',
		inputIcon: '',
		options: [],
		value: ''
	})
];
export const groupControls: Control[] = [
	new Control({
		id: 'Group 1',
		label: 'Group 1',
		type: ControlType.checkbox,
		inputPlaceholderText: '',
		inputIcon: '',
		options: [],
		value: ''
	}),
	new Control({
		id: 'Group 2',
		label: 'Group 2',
		type: ControlType.checkbox,
		inputPlaceholderText: '',
		inputIcon: '',
		options: [],
		value: ''
	}),
	new Control({
		id: 'Group 3',
		label: 'Group 3',
		type: ControlType.checkbox,
		inputPlaceholderText: '',
		inputIcon: '',
		options: [],
		value: ''
	})
];
export const locationControls: Control[] = [
	new Control({
		id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
		label: '',
		type: ControlType.input,
		inputPlaceholderText: '',
		inputIcon: '',
		options: [],
		value: ''
	}),
	new Control({
		id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
		label: 'Location ABC',
		type: ControlType.checkbox,
		inputPlaceholderText: '',
		inputIcon: '',
		options: [],
		value: true
	}),
	new Control({
		id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
		label: 'Location DEF',
		type: ControlType.checkbox,
		inputPlaceholderText: '',
		inputIcon: '',
		options: [],
		value: false
	})
];

export const locationSection: Section =
    {
    	label: 'Location',
    	noResultsFoundText: '',
    	controls: [...locationControls],
    	collapsed: true,
    	accordionCollapsedIcon: { altText: '', iconPath: '' },
    	accordionExpandedIcon: { altText: '', iconPath: '' },
    	searchIcon: { iconPath: '', altText: '' },
    	crossIcon: { iconPath: '', altText: '' }
    };

export const divisionSection: Section =
    {
    	label: 'Division',
    	noResultsFoundText: '',
    	controls: divisionControls,
    	collapsed: true,
    	accordionCollapsedIcon: { altText: '', iconPath: '' },
    	accordionExpandedIcon: { altText: '', iconPath: '' },
    	searchIcon: { iconPath: '', altText: '' },
    	crossIcon: { iconPath: '', altText: '' },
    	isShowMorePresent: true,
    	showMoreShowLess: {
    		isDisabled: false,
    		isShowMoreClicked: false,
    		showLessText: '',
    		showMoreText: ''
    	}
    };
export const groupSection: Section =
    {
    	label: 'Group',
    	noResultsFoundText: '',
    	controls: groupControls,
    	collapsed: true,
    	accordionCollapsedIcon: { altText: '', iconPath: '' },
    	accordionExpandedIcon: { altText: '', iconPath: '' },
    	searchIcon: { iconPath: '', altText: '' },
    	crossIcon: { iconPath: '', altText: '' },
    	isShowMorePresent: true,
    	showMoreShowLess: {
    		isDisabled: false,
    		isShowMoreClicked: false,
    		showLessText: '',
    		showMoreText: ''
    	}
    };
export const dateRangeSection: Section = {
	label: 'Date Range',
	controls: [
		new Control({
			id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
			label: '',
			type: ControlType.radio,
			inputPlaceholderText: '',
			inputIcon: '',
			options: [
				{
					label: 'Custom Date Range',
					value: '',
					checked: false
				},
				{
					label: 'Last 60 Days',
					value: '',
					checked: false
				},
				{
					label: 'Last 60 Days (default)',
					value: '',
					checked: false
				}
			],
			value: ''
		})
	],
	accordionCollapsedIcon: SharedFactoryDataService.getAccordionCollapsedIcon(),
	accordionExpandedIcon: SharedFactoryDataService.getAccordionExpandedIcon(),
	searchIcon: SharedFactoryDataService.getSearchIcon(),
	crossIcon: SharedFactoryDataService.getSearchCrossIcon(),
	collapsed: true
};
export const locationHeirarchyObject: ProfileLocation =	{
	locations: [
		{
			isParentCompany: false,
			companyName: 'TRACTOR SUPPLY COMPANY',
			locationId: 'Location 1',
			locationName: 'Location 1',
			companyId: '',
			address: {
				addressLine1: '5401 Virginia Way',
				addressLine2: '',
				city: 'Brentwood',
				state: 'TN',
				country: 'US',
				zipCode: '34242'
			}
		},
		{
			isParentCompany: false,
			companyName: 'test',
			locationId: 'Location 2',
			locationName: 'Location 2',
			companyId: '',
			address: {
				addressLine1: '5401 Virginia Way',
				addressLine2: '',
				city: 'Brentwood',
				state: 'TN',
				country: 'US',
				zipCode: '34242'
			}
		},
		{
			isParentCompany: false,
			companyName: 'test',
			locationId: 'Location 3',
			locationName: 'Location 3',
			companyId: '',
			address: {
				addressLine1: '5401 Virginia Way',
				addressLine2: '',
				city: 'Brentwood',
				state: 'TN',
				country: 'US',
				zipCode: '34242'
			}
		},
		{
			isParentCompany: false,
			companyName: 'TRACTOR SUPPLY COMPANY',
			locationId: '123456',
			locationName: 'Philadelphia, GA',
			companyId: '',
			address: {
				addressLine1: '5401 Virginia Way',
				addressLine2: '',
				city: 'Brentwood',
				state: 'TN',
				country: 'US',
				zipCode: '34242'
			}
		}
	],
	divisionFilterList: [
		{
			divisionName: 'Division 1',
			groups: [
				{
					groupName: 'Group 1',
					locations: [
						{
							isParentCompany: false,
							companyName: 'TRACTOR SUPPLY COMPANY',
							locationId: 'Location 1',
							locationName: 'Location 1',
							companyId: '',
							address: {
								addressLine1: '5401 Virginia Way',
								addressLine2: '',
								city: 'Brentwood',
								state: 'TN',
								country: 'US',
								zipCode: '37027-7536'
							}
						},
						{
							isParentCompany: false,
							companyName: 'TRACTOR SUPPLY COMPANY',
							locationId: 'Location 2',
							locationName: 'Location 2',
							companyId: '',
							address: {
								addressLine1: '5401 Virginia Way',
								addressLine2: '',
								city: 'Brentwood',
								state: 'TN',
								country: 'US',
								zipCode: '37027-7536'
							}
						}
					]
				},
				{
					groupName: null as unknown as string,
					locations: [
						{
							isParentCompany: false,
							companyName: 'TRACTOR SUPPLY COMPANY',
							locationId: 'Location 3',
							locationName: 'Location 3',
							companyId: '',
							address: {
								addressLine1: '5401 Virginia Way',
								addressLine2: '',
								city: 'Brentwood',
								state: 'TN',
								country: 'US',
								zipCode: '37027-7536'
							}
						}
					]
				}
			]
		},
		{
			divisionName: null as unknown as string,
			groups: [
				{
					groupName: 'Group 3',
					locations: [
						{
							isParentCompany: false,
							companyName: 'TRACTOR SUPPLY COMPANY',
							locationId: 'Location 4',
							locationName: 'Location 4',
							companyId: '',
							address: {
								addressLine1: '5401 Virginia Way',
								addressLine2: '',
								city: 'Brentwood',
								state: 'TN',
								country: 'US',
								zipCode: '37027-7536'
							}
						}
					]
				},
				{
					groupName: null as unknown as string,
					locations: [
						{
							isParentCompany: false,
							companyName: 'TRACTOR SUPPLY COMPANY',
							locationId: 'Location 5',
							locationName: 'Location 5',
							companyId: '',
							address: {
								addressLine1: '5401 Virginia Way',
								addressLine2: '',
								city: 'Brentwood',
								state: 'TN',
								country: 'US',
								zipCode: '37027-7536'
							}
						}
					]
				}
			]
		}
	],
	groupsList: [
		'Group 1'
	],
	divisionsList: [
		'Division 1'
	]
};

export const filterStateMock: KngFilterState = {
	filterData: {
		heading: { label: '' },
		sections: [ divisionSection, groupSection, locationSection ],
		ctaList: [
			{ id: '327147f4-c044-4799-8a5a-d075c619e41c', label: '', className: 'light', disabled: false },
			{ id: '7eeaa3f0-b4f6-4142-8086-361298d75686', label: '', className: 'dark', disabled: false }
		]
	},
	hidden: true
};
